export const Forbidden = () => {
  return (
    <>
      <div>権限がありません。</div>
    </>
  );
};
